import axios, { getAuthHeaders } from './config'

export default {

    countDocument: function() {
        return axios.get('file-manager/count-documents', {
            headers: getAuthHeaders()
        })
    },
    documentsSize: function() {
        return axios.get('file-manager/documents-size', {
            headers: getAuthHeaders()
        })
    },
    getDocumentById: function(id) {
        return axios.get(`file-manager/get-document/${id}`, {
            headers: getAuthHeaders()
        })
    },
    getDocumentPath: function(id) {
        return axios.get(`file-manager/document-path/${id}`, {
            headers: getAuthHeaders()
        })
    },
    listdocuments: function() {
        return axios.get('file-manager/list-documents', {
            headers: getAuthHeaders()
        })
    },
    documentMetadata: function(docId) {
        return axios.get(`/document-metadata/${docId}`, {
            headers: getAuthHeaders()
        })
    },
    modifyDocumentType: function(data) {
        return axios.post(`file-manager/documents/document-type/edit`, data, {
            headers: getAuthHeaders()
        })
    }
}